/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRegimenCycle } from 'app/shared/model/regimen-cycle.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { ITreatmentRegimen } from 'app/shared/model/treatment-regimen.model';

export interface ITreatmentCycle {
  id?: string;
  cycleNumber?: number | null;
  startDate?: number | null;
  endDate?: number | null;
  status?: string | null;
  hasChemoPort?: boolean | null;
  catheterSite?: string | null;
  gauge?: string | null;
  noOfAttempts?: number | null;
  difficultIV?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  notes?: string | null;
  cycle?: IRegimenCycle | null;
  vitals?: IVitals | null;
  regimen?: ITreatmentRegimen | null;
}

export const defaultValue: Readonly<ITreatmentCycle> = {
  hasChemoPort: false,
  difficultIV: false,
  active: false,
};
